$(document).ready(function () {
  $(".gnav-menu__btn").click(function () {
    $(this).toggleClass("--active");
    $(this).next(".gnav-menu__inner").slideToggle();
  });
});

if (document.querySelector(".top-slider")) {
  const topSwiper = new Swiper(".top-slider .swiper", {
    loop: true,
    slidesPerView: 1,
    speed: 1000,
    autoplay: {
      delay: 3000,
    },
  });
}
